import AddIcon from '@mui/icons-material/Add';
import { Box, Container, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import List from "@mui/material/List";
import makeStyles from '@mui/styles/makeStyles';
import * as actions from "actions";
import SearchBar from "components/common/SearchBar";
import { prop } from "ramda";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContractorListItem from "./ContractorListItem";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    position: "relative",
    overflow: "auto",
  },
  ul: {
    padding: 0,
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
  },
  item: {
    border: "1px solid rgb(216,216,216)",
    padding: "10px",
    borderRadius: "6px",
    marginBottom: "16px",
  },
}));

export default function ContractorList({ height, onItemSelect, onAddNewContractor }) {
  const classes = useStyles();
  const handleClick = (contractor) => () => !!onItemSelect && onItemSelect(contractor);
  const handelNewContractorClick = () => !!onAddNewContractor && onAddNewContractor();


  const dispatch = useDispatch();
  const updateAll = () => {
    dispatch(actions.getContractors());
  }

  useEffect(updateAll, []);
  const { contractors, scrollPosition } = useSelector(prop('contractor'));
  const [filteredList, setFilteredList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const onSearch = (e) => {
    setSearchText(e.target.value.trim().toLowerCase());
  }

  useEffect(() => {
    let filterdList = contractors ? contractors : [];
    if (searchText.length>0) {
     filterdList = filterdList.filter(k=>k.FirstName?.toLowerCase().includes(searchText));
    } 
    setFilteredList(filterdList)
  }, [contractors, searchText]);


  const setScrollPosition = () => {
    const table = document.getElementById('table-container-contractors');
    if (table) {
      table.scrollTop = scrollPosition;
    }
  };

  const handleTableScroll = (event) => {
    const currentPosition = event.target.scrollTop;
    dispatch(actions.setContractorProps({ scrollPosition: currentPosition }));
  };
  React.useEffect(() => {
    setScrollPosition();
  }, [filteredList]);

  return (
    <Container id="table-container-contractors"
      onScroll={handleTableScroll} sx={{ height: 'calc(100vh - 70px)', overflow: 'auto' }}>
      <Box mt={4}>
        <Typography variant="h5" gutterBottom>
          <strong data-testid="label-user-administration">
          Hirani Clients
          </strong>
        </Typography>
        <Typography
          color="textSecondary"
          data-testid="label-user-administration-secondary-text"
        >
          Add as many Hirani Clients as you want.
        </Typography>
      </Box>
      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          <strong data-testid="label-user-administration-list-user">
            A list of Hirani Clients
          </strong>
        </Typography>
        <SearchBar placeHolder='Type to Search' onChange={onSearch}></SearchBar>

      </Box>
      <List className={classes.root} style={{ height }} dense={false}>
        <ul className={classes.ul}>
          {filteredList?.map((contractor) => (
            <ContractorListItem
              key={contractor.Id}
              contractor={contractor}
              onClick={handleClick(contractor)}
              itemClasses={classes.item}
              
            />
          ))}

          <ListItem
            dense
            disableGutters
            onClick={onAddNewContractor}
            className={classes.item}
            data-testid={'li-add-user'}
          >
            <ListItemAvatar>
              <AddIcon />
            </ListItemAvatar>
            <ListItemText
              primary={'Add a Hirani Clients'}
              primaryTypographyProps={{ className: "bold" }}
            />
          </ListItem>
        </ul>
      </List>
    </Container>
  );
}
